<div class="row">
    <div class="xl:col-8 lg:col-8 col-12">
        <h1>Mijn Ebem</h1>
        <p-tabs [className]="'simple-selector hide-active-bar'" [(value)]="activeTab" [showNavigators]="true" [scrollable]="true" class="w-full">
            <p-tablist>
                <p-tab [value]="'overview'">Overzicht</p-tab>
                <p-tab [value]="'invoices'">Facturen</p-tab>
                <p-tab [value]="'usage'">Verbruik</p-tab>
                <p-tab [value]="'payment-method'">Betaalwijze</p-tab>
                <p-tab [value]="'contract'">Contract</p-tab>
                <p-tab [value]="'data'">Gegevens</p-tab>
            </p-tablist>
            <p-tabpanels></p-tabpanels>
            <br/>
            <br/>
        </p-tabs>
    </div>
    <div class="xl:col-4 lg:col-4 col-12">
    </div>
</div>
<div class="row">
    <div class="col-12 backgroundLighterGray">
        <br/>
        <br/>
        <p-tabs [value]="activeTab">
            <p-tablist [className]="'hide-active-bar'"></p-tablist>
            <p-tabpanels [className]="'backgroundLighterGray'">
                <p-tabpanel [value]="'overview'">
                    <div class="row">
                        <div class="backgroundLighterGray xl:col-4 lg:col-4 col-12">
                            <invoices-dashboard-component [(activeTab)]="activeTab"></invoices-dashboard-component>
                            <br/>
                            <payment-method-dashboard-component [(activeTab)]="activeTab"></payment-method-dashboard-component>
                        </div>
                        <div class="backgroundLighterGray xl:col-8 lg:col-8 col-12">
                            <consumption-dashboard-component [(activeTab)]="activeTab"></consumption-dashboard-component>
                        </div>
                    </div>
                    <div class="row">
                        <div class="backgroundLighterGray xl:col-8 lg:col-8 col-12">
                            <contracts-dashboard-component [(activeTab)]="activeTab"></contracts-dashboard-component>
                        </div>
                        <div class="backgroundLighterGray xl:col-4 lg:col-4 col-12">
                            <customer-dashboard-component [(activeTab)]="activeTab"></customer-dashboard-component>
                        </div>
                    </div>

                </p-tabpanel>
                <p-tabpanel [value]="'invoices'">
                    <div class="backgroundLighterGray">
                        <h3><img class="icon-smaller" src="icons/invoices-icon.png">Facturen</h3>
                        <invoices-component></invoices-component>
                    </div>
                </p-tabpanel>
                <p-tabpanel [value]="'usage'">
                    <div class="backgroundLighterGray">
                    <h3><img class="icon-smaller" src="icons/usage-icon.png">Verbruik</h3>
                    <p-card class="xl-radius">
                        <consumption-graph-component></consumption-graph-component>
                    </p-card>
                    </div>
                </p-tabpanel>
                <p-tabpanel [value]="'payment-method'">
                    <h3><img class="icon-smaller" src="icons/payment-method-icon.png">Betaalwijze</h3>
                    <payment-method-component></payment-method-component>
                </p-tabpanel>
                <p-tabpanel [value]="'contract'">
                    <h3><img class="icon-smaller" src="icons/contract-icon.png">Contract</h3>
                    <p-card class="xl-radius">
                        <contracts-component [showButton]="true" [showExplanation]="true"></contracts-component>
                    </p-card>
                </p-tabpanel>
                <p-tabpanel [value]="'data'">
                    <h3><img class="icon-smaller" src="icons/data-icon.png">Gegevens</h3>
                    <customer-details-component></customer-details-component>
                </p-tabpanel>
            </p-tabpanels>
        </p-tabs>
    </div>   
</div>